import { MERCHANDISE_TYPES } from '@sorare/core/src/types/shopItems';

import { ShopItemPicker } from '@sorare/gameplay/src/components/shopItems/ShopItemPicker';

const ClubShopMerchPage = () => {
  return <ShopItemPicker types={[...MERCHANDISE_TYPES]} />;
};

export default ClubShopMerchPage;
